import { baseApi } from "./baseApi";

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (payload) => ({
        url: "/auth/login",
        method: "POST",
        body: payload,
      }),
    }),
    forgotPassword: builder.mutation({
      query: ({ email, password, token }) => ({
        url: "/auth/forgot_password",
        method: "PUT",
        body: { email, password, token },
      }),
    }),
    verifyEmail: builder.mutation({
      query: (payload: { email: string }) => ({
        url: "/auth/forgot_password",
        method: "PUT",
        body: payload,
      }),
    }),
    disableAccount: builder.mutation({
      query: (token) => ({
        url: "/auth/disable_account",
        method: "PUT",
        body: { token },
      }),
    }),
    createPassword: builder.mutation({
      query: ({ email, password, token }) => ({
        url: "/auth/create_password",
        method: "POST",
        body: { email, password, token },
      }),
    }),
    changePassword: builder.mutation({
      query: ({ oldPassword, newPassword }) => ({
        url: "/auth/reset_password",
        method: "PUT",
        body: { old_password: oldPassword, password: newPassword },
      }),
    }),
    getClientConfig: builder.query({
      query: () => ({
        url: "/client_config",
        method: "GET",
      }),
    }),
    clientConfig: builder.mutation({
      query: () => ({
        url: "/client_config",
        method: "GET",
      }),
    }),
    getUserDetails: builder.mutation({
      query: (userId) => ({
        url: `/users/get-user-details/${userId}`,
        method: "GET",
      }),
    }),
    getUserClients: builder.mutation({
      query: () => ({
        url: `/users/clients`,
        method: "GET",
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
    }),
    getEmailSignature: builder.query<{ email_signature: string }, void>({
      query: () => ({
        url: "/users/email-signature",
        method: "GET",
      }),
    }),
    updateEmailSignature: builder.mutation<
      { email_signature: string },
      { html_content: string }
    >({
      query: (payload) => ({
        url: "/users/email-signature",
        method: "PUT",
        body: payload,
      }),
    }),
    updateProfile: builder.mutation({
      query: ({ userId, formData }) => ({
        url: `/users/${userId}`,
        method: "PATCH",
        body: formData,
      }),
    }),
    getUnsubscribeReason: builder.query({
      query: (channel: string) => ({
        url: `/unsubscribe/reasons?channel=${channel}`,
        method: "GET",
      }),
    }),
    unsubscribe: builder.mutation({
      query: (payload: { channel: string; reason: string; token: string }) => ({
        url: `/unsubscribe/submit`,
        method: "POST",
        body: payload,
      }),
    }),
    getIntegrationStatus: builder.mutation<
      { is_integration_available: boolean; integration_status: boolean },
      { user_email: string }
    >({
      query: ({ user_email }) => ({
        url: `/integration`,
        method: "GET",
        params: { user_email },
      }),
    }),
    connectOutlook: builder.mutation<void, { user_email: string }>({
      query: ({ user_email }) => ({
        url: `/integration/connect`,
        method: "POST",
        body: { user_email },
      }),
    }),
    disconnectOutlook: builder.mutation<
      { integration_status: boolean },
      void
    >({
      query: () => ({
        url: `/integration/disconnect`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useSignInMutation,
  useForgotPasswordMutation,
  useVerifyEmailMutation,
  useDisableAccountMutation,
  useCreatePasswordMutation,
  useChangePasswordMutation,
  useGetClientConfigQuery,
  useClientConfigMutation,
  useGetUserClientsMutation,
  useGetUserDetailsMutation,
  useLogoutMutation,
  useGetEmailSignatureQuery,
  useLazyGetEmailSignatureQuery,
  useUpdateEmailSignatureMutation,
  useUpdateProfileMutation,
  useGetUnsubscribeReasonQuery,
  useUnsubscribeMutation,
  useGetIntegrationStatusMutation,
  useConnectOutlookMutation,
  useDisconnectOutlookMutation,
} = authApi;
